import moment from 'moment-timezone';
import HttpReports from '../../../httpReports';
import { FETCH_SHOP_RETENTION } from './constants';
import { downloadCsv } from '../../reports/helpers';

export const shopRetention = payload => ({
  type: FETCH_SHOP_RETENTION,
  payload,
});

export const fetchShopRetention = (shopId, quarter, year, customerRetainedVisitsCount = 2) => dispatch =>
  HttpReports
    .get(`/shop/${shopId}/report/retention/${quarter}/${year}/${customerRetainedVisitsCount}`)
    .then(data => dispatch(shopRetention(data)));

export function getRetentionReportCsv({ shopId, shopName, quarter, year, timezone, customerRetainedVisitsCount = 2 }) {
  const endpoint = `/shop/${shopId}/report/retention/${quarter}/${year}/${customerRetainedVisitsCount}`;
  const date = moment.tz(timezone).year(year).quarter(quarter).format('Qo[ quarter of ]YYYY');

  return HttpReports.getRaw(endpoint, { view: 'csv' }).then(response =>
    downloadCsv(response, `${shopName} - Retention report for ${date}.`)
  );
}
